<template>
  <div class="el_1_064d93b2d8de85a1feb7b951d2425eea relative">
    <label
      :for="item.field" class="relative cursor-pointer block text-sm font-medium uppercase text-primary-800"
      @click="$emit('sticky')"
    >
      <span v-if="item.required" class="el_2_064d93b2d8de85a1feb7b951d2425eea inline mr-1 text-sm text-red-400">*</span>
      <InformationCircleIcon
        v-if="item.popover" class="inline-block w-4 h-4 mb-1 ml-1 cursor-pointer"
        @click="show_help = !show_help"
      />
      {{ item.name }}
      <svg
        v-if="item.sticky" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
        stroke="currentColor" class="w-5 h-5 inline text-red-500"
      >
        <path
          stroke-linecap="round" stroke-linejoin="round"
          d="M16.5 10.5V6.75a4.5 4.5 0 1 0-9 0v3.75m-.75 11.25h10.5a2.25 2.25 0 0 0 2.25-2.25v-6.75a2.25 2.25 0 0 0-2.25-2.25H6.75a2.25 2.25 0 0 0-2.25 2.25v6.75a2.25 2.25 0 0 0 2.25 2.25Z"
        />
      </svg>

    </label>
    <div class="date-input-wrapper">
      <TgDatePicker
        :min="min" :max="max" :dt="modelValue" :inline="true"
        :disabled="loading || item.disabled || item.lock_edits"
        :class="[error ? 'border-red-500' : '', item.sticky ? 'bg-yellow-50' : '']" @on:update="datePicked"
      />
    </div>
    <div
      v-if="show_help && item.popover"
      class="el_5_064d93b2d8de85a1feb7b951d2425eea absolute left-0 z-40 p-2 mt-1 border rounded-lg shadow-lg top-16 text-primary-700 bg-primary-100 border-primary-300"
      @click="show_help = false"
    >
      <InformationCircleIcon class="inline-block w-6 h-6 mr-1" /> {{ item.popover }}
    </div>
  </div>
</template>

<script>
import TgDatePicker from "@/components/Common/TgDatePicker.vue";
import dayjs from "dayjs";
import { InformationCircleIcon } from "@heroicons/vue/outline";
export default {
  components: {
    InformationCircleIcon,
    TgDatePicker,
  },
  props: {
    item: Object,
    error: String,
    modelValue: {
      type: [Date, String],
      default: "",
    },
  },
  emits: ["update:modelValue", "sticky"],
  data() {
    return {
      show_help: false,
      loading: false,
      min: null,
      max: null,
    };
  },
  watch: {
    modelValue: {
      immediate: true,
      deep: false,
      handler(newVal) {
        // Value is now handled directly by TgDatePicker
      },
    },
  },
  created() {
    if (this.item.dt_min) this.min = dayjs().add(this.item.dt_min);

    if (this.item.dt_max) this.max = dayjs().add(this.item.dt_max);
  },
  methods: {
    datePicked(dt) {
      console.log("dt = ", dt);
      this.$emit("update:modelValue", dt);
    },
  },
};
</script>

<style></style>
